// Lightweight per-route SEO hook. Mutates document.title and meta tags on mount.
// GoogleBot executes JS so this is picked up by indexing (since 2019).
import { useEffect } from 'react';

const SITE_NAME = 'Vendetucasa.ar';
const DEFAULT_OG_IMAGE = 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=630&fit=crop';

const upsertMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    // Build the missing attribute from the selector (e.g., property="og:title" or name="description")
    const m = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const upsertCanonical = (href) => {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const useSeo = ({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogImage = DEFAULT_OG_IMAGE,
  ogUrl,
  twitterTitle,
  twitterDescription,
}) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      upsertMeta('meta[name="description"]', 'content', description);
    }

    upsertMeta('meta[property="og:title"]', 'content', ogTitle || title);
    upsertMeta('meta[property="og:description"]', 'content', ogDescription || description);
    upsertMeta('meta[property="og:image"]', 'content', ogImage);
    if (ogUrl) upsertMeta('meta[property="og:url"]', 'content', ogUrl);
    upsertMeta('meta[property="og:site_name"]', 'content', SITE_NAME);
    upsertMeta('meta[property="og:type"]', 'content', 'website');
    upsertMeta('meta[property="og:locale"]', 'content', 'es_AR');

    upsertMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    upsertMeta('meta[name="twitter:title"]', 'content', twitterTitle || ogTitle || title);
    upsertMeta('meta[name="twitter:description"]', 'content', twitterDescription || ogDescription || description);
    upsertMeta('meta[name="twitter:image"]', 'content', ogImage);

    upsertCanonical(canonical || ogUrl);
  }, [title, description, canonical, ogTitle, ogDescription, ogImage, ogUrl, twitterTitle, twitterDescription]);
};
